exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-a1afdab4]{background-color:var(--background-color);color:var(--text-color)}.slideshow[data-v-a1afdab4]{--component-padding:50px;margin-top:0;padding-bottom:var(--component-padding)}.slideshow .vw-component[data-v-a1afdab4]{--component-padding:30px}@media (min-width:48em) and (max-width:74.99em){.slideshow[data-v-a1afdab4]{--component-padding:90px;padding-bottom:var(--component-padding)}.slideshow .vw-component[data-v-a1afdab4]{--component-padding:50px}}@media (min-width:75em){.slideshow[data-v-a1afdab4]{--component-padding:125px;padding-bottom:var(--component-padding)}.slideshow .vw-component[data-v-a1afdab4]{--component-padding:50px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a1afdab4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/AppSlideShow.vue
// module id = QRqC
// module chunks = 4